"use client";
import React, { useState } from "react";
 import "./SliderSP.css"
export default function CardCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const cards = [
    "/slider/1.png",
    "/slider/2.png",
    "/slider/3.png",
    "/slider/4.png",
    "/slider/5.png",
    "/slider/6.png",
    "/slider/7.png",
  ];

  const totalCards = cards.length;

  const getCardPosition = (index) => {
    const position = index - currentIndex;

    if (position === 0) return "SPSLIDER_active";
    if (position === -1 || position === totalCards - 1) return "SPSLIDER_left-1";
    if (position === -2 || position === totalCards - 2) return "SPSLIDER_left-2";
    if (position === -3 || position === totalCards - 3) return "SPSLIDER_left-3";
    if (position === 1 || position === -(totalCards - 1)) return "SPSLIDER_right-1";
    if (position === 2 || position === -(totalCards - 2)) return "SPSLIDER_right-2";
    if (position === 3 || position === -(totalCards - 3)) return "SPSLIDER_right-3";

    return "SPSLIDER_hidden";
  };

  return (
    <div className="SPSLIDER_screen">
     

      <div className="SPSLIDER_card-wrapper">
        {cards.map((src, index) => (
          <div
            key={index}
            className={`SPSLIDER_card ${getCardPosition(index)}`}
            onClick={() => setCurrentIndex(index)}
          >
            <div className="SPSLIDER_card-bg">
              <div className="SPSLIDER_card-img magiCcenter">
                <img src={src} alt={`card-${index}`}  />
              </div>
            </div>
          </div>
        ))}
      </div>
          <div className="slider-content-background" />
    </div>
  );
}